import { render, staticRenderFns } from "./FPotensiTable.vue?vue&type=template&id=8f9e1d84&scoped=true"
import script from "./FPotensiTable.vue?vue&type=script&lang=js"
export * from "./FPotensiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9e1d84",
  null
  
)

export default component.exports